;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .controller('VulnNoteCtrl', VulnNoteCtrl)

  function VulnNoteCtrl(
    $scope,
    $routeParams,
    ApplicationFactory,
    traceRenderService,
    UserService,
    ErrorService,
    ORG_VULN_EVENTS,
    APPLICATION_LICENSES
  ) {
    'ngInject'

    var _uuid

    function init() {
      _uuid = $routeParams.uuid

      $scope.$on('traces:overview:load', function () {
        _getInformation()
      })

      _emitTraceActiveEvent()

      if ($scope.model.trace && !$scope.model.servers) {
        _getInformation()
      }
    }

    function _getInformation() {
      var appId = $scope.model.appId
      traceRenderService.getTraceServer($scope, appId, _uuid)
      traceRenderService.getTraceRequirements($scope, appId, _uuid)
      ApplicationFactory.getLicense(appId)
        .then(function (response) {
          if (
            !UserService.isFreemiumOrganization() &&
            APPLICATION_LICENSES.LICENSED === response.data.license.level
          ) {
            $scope.model.showRoutes = true
            traceRenderService.getTraceRoutes($scope, appId, _uuid)
            traceRenderService.getVulnerabilityInstanceMetadata(
              $scope,
              appId,
              _uuid
            )
            traceRenderService.getVulnerabilityInstancesDetails(
              $scope,
              appId,
              _uuid
            )
          } else {
            $scope.model.showRoutes = false
          }
        })
        .catch(ErrorService.processError)
    }

    function _emitTraceActiveEvent() {
      var eventName = ORG_VULN_EVENTS.ORG_TRACE_ACTIVE
      if ($routeParams.serverId) {
        eventName = ORG_VULN_EVENTS.SERVER_TRACE_ACTIVE
      } else if ($routeParams.appId) {
        eventName = ORG_VULN_EVENTS.APP_TRACE_ACTIVE
      }
      $scope.$emit(eventName, { active: 'notes' })
    }

    init()
  }
})()
